// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9o-0";
export var orangeButton = "_9o-1";